import Vue from "vue";
import Vuex from "vuex";

import getters from "../getters";
import actions from "../actions";
import mutations from "../mutations";
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);
//have vuex involved
Vue.use(Vuex);

const state = {
  userId: Vue.localStorage.get("userId"),
  companyId: Vue.localStorage.get("companyId"),
  users: JSON.parse(Vue.localStorage.get("users"))
    ? JSON.parse(Vue.localStorage.get("users"))
    : [],
  user: JSON.parse(Vue.localStorage.get("user"))
    ? JSON.parse(Vue.localStorage.get("user"))
    : {},
  newuser: {},
  buildings: {
    buildingsList: JSON.parse(Vue.localStorage.get("edificios"))
      ? JSON.parse(Vue.localStorage.get("edificios"))
      : [],
    controlPointList: [],
    taskList: [],
    resultData: {}
  },
  dashBuildings: [],
  configuration: {
    headerColor: "",
    menuColor: "",
    logo: {}
  },
  company: {},
  conectionState: false,
  modalEdificio: false,
  modalDelete: false,
  showSidebar: false,
  imageTemp: {},
  newControlPoint: {},
  currentUser: {},
  currentCP: {},
  cp_id: Vue.localStorage.get("cp_id") ? Vue.localStorage.get("cp_id") : "",
  alternativas: [],
  localListBuild: [],
  dashinfo: {},
  reportInfo: {},
  colorDash: false,
  colorEdificios: false,
  colorDiseño: false,
  colorUsers: false,
  colorStat: false,
  colorStCheckpoint: false,
  colorStRep: false,
  colorDown: false,
  isMaster: false || window.localStorage.getItem("isMaster"),
  canEdit: false,
  statCPs: [],
  statisticsCheckpointsChart: {},
  statisticsUsersTable: [],
  statisticsUsersChart: null,
  statisticsUsersChartHour: null,
  currentCPStat: {},
  currentCheckpointChart: {},
  currentCheckpointChartEdi: {},
  currentReporterChart: {},
  currentReporterList: [],
  buildingsChart: null,
  buildingsChartPayload: null,
  buildingsStatList: [],
  buildingsStatTable: [],
  buildingChartHistoric: null,
  isLoader: true,
  businessList: [],
  usersOwners: [],
  onwerDetail: null,
  businessCurrentView: {},
  apiKey: null,
  errorMessage: null,
  businessImage: null,
  subdomain: null,
  namespace: localStorage.getItem("namespace") || "maintenance",
  checkpointTypes: null
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
});



// WEBPACK FOOTER //
// ./src/vuex/store/index.js